import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  const [adminAccessToken, setAdminAccessToken] = useState(
    localStorage.getItem("admin_access") || ""
  );

  const [adminRefreshToken, setAdminRefreshToken] = useState(
    localStorage.getItem("admin_refresh") || ""
  );

  const navigate = useNavigate();

  const adminLogin = ({ access, refresh }) => {
    setAdminAccessToken(access);
    setAdminRefreshToken(refresh);

    localStorage.setItem("admin_access", access);
    localStorage.setItem("admin_refresh", refresh);

    navigate("/admin-dashboard", { replace: true });
  };

  const adminLogout = () => {
    setAdminAccessToken("");
    setAdminRefreshToken("");

    localStorage.removeItem("admin_access");
    localStorage.removeItem("admin_refresh");

    navigate("/admin-login", { replace: true });
  };

  const isAdminTokenValid = () => {
    if (!adminAccessToken) return false;

    try {
      const decoded = jwtDecode(adminAccessToken);
      return dayjs.unix(decoded.exp).diff(dayjs()) > 0;
    } catch {
      return false;
    }
  };

  return (
    <AdminAuthContext.Provider
      value={{
        adminAccessToken,
        adminRefreshToken,
        adminLogin,
        adminLogout,
        isAdminTokenValid,
      }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
